'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Overlay = require('react-bootstrap/lib/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Overlay2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Overlay.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Overlay.js
 ** module chunks = 0
 **/